import { usePages } from "@shapeable/ui";
import { isLandmarkReportPage } from "../types";
import { transformPage } from "../utils/transforms";

export const useLandmarkReports = () => (usePages().filter(isLandmarkReportPage).map(transformPage));
